<bp-hl-area-container name="Bemerkungen">
	<div class="touch-form">
		<div class="form-row" *ngIf="isString(data.extendedHeader.baumarten)">
			<div class="form-label-cell">Bestand</div>
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bestand" [(model)]="data.extendedHeader.baumarten"></wd-multiline-text-input>
			</div>
		</div>
		<div class="form-row">
			<div class="form-label-cell">Bemerkungen</div>
			<div class="form-input-cell full-width">
				<wd-multiline-text-input name="Bemerkungen" [(model)]="data.header.bemerkungen"></wd-multiline-text-input>
			</div>
		</div>
	</div>
</bp-hl-area-container>
